import { EnvConfig } from './types/env.types'

export const env: EnvConfig = {
  baseUrl: 'https://api.beattractive.fr/',
  sentryDsn: 'https://c601aea1ba6144008e1e3885898f7755@o1300890.ingest.sentry.io/6549943',
  clientUuid: 'a1429770-f830-4d99-a620-a7bb766b2f2b',
  ENV: 'laBresse',
  featureFlags: {
    areCheatCodesEnabled: false,
    isCodePushEnabled: false,
    isCodePushManual: false,
    isFavoritesEnabled: false,
  },
  matomoUrlBase: 'https://analytics.tools.citopia.fr/',
  matomoSiteId: 38,
  baseSurveyUrl: 'https://sondage.prod.tools.citopia.fr/survey',
}
